import { Menu, MenuItem } from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LIMIT_PER_PAGE } from "../../Common/Constants";
import { debounce } from "../../Common/debounce";
import { Loader } from "../../Common/Loader";
import { Pagination } from "../../Common/Pagination";
import { Table } from "../../Common/Table";
import useDebounce from "../../Common/useDebounce";
import { CallInstantModal } from "../../Model/CallInstantModal";
import { ErrorModel } from "../../Model/ErrorModel";
import InstantEmailModal from "../../Model/InstantEmailModal";
import LowCreditModal from "../../Model/LowCreditModal";
import { SuccessModel } from "../../Model/SuccessModel";
import { getCallHistoryList } from "../../Redux/Slice/CallEmailHistory/GetCallHistoryListSlice";
import {
  setPage,
  setTotalItems,
  setTotalPages,
} from "../../Redux/Slice/Common/PaginationSlice";
import { ChatSummaryPopup } from "../Chat/ChatSummaryPopup";
import { ScheduleCallPopup } from "../Contacts/ScheduleCallPopup";
import { ScheduleEmailPopup } from "../Contacts/ScheduleEmailPopup";

const CallEmailHistoryList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [schedulePopup, showSchedulePopup] = useState(false);
  const [scheduleEmailPopup, showScheduleEmailPopup] = useState(false);
  const [showInstantCallPopup, setShowInstantCallPopup] = useState({
    visible: false,
    data: null,
  });
  const [showInstantEmailPopup, setShowInstantEmailPopup] = useState({
    visible: false,
    data: null,
  });
  const CallHistoryListData = useSelector(
    (state) => state.callHistoryList.callHistoryListData
  );
  const { userPlanFeatures } = useSelector((s) => s?.userPlanDetails);
  const [showLowCreditModal, setShowLowCreditModal] = useState(false);
  const [callHistoryList, setCallHistoryList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const searchQuery = useDebounce(searchText, 500);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [localItemsPerPage, setLocalItemsPerPage] = useState(LIMIT_PER_PAGE);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const INITIAL_SUMMARY_POPUP = {
    visible: false,
    data: null,
  };
  const [summaryPopup, setSummaryPop] = useState(INITIAL_SUMMARY_POPUP);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isAllChecked = () => {
    const currentList = callHistoryList;
    const found = currentList.some((x) => !x.checkedRow);
    if (found || !currentList?.length) {
      return false;
    } else {
      return true;
    }
  };

  const allChecked = isAllChecked();

  const closePopup = (value = "default", error = null) => {
    showSchedulePopup(false);
    setSelectedHistory(null);
    if (value === "success") {
      setSuccessMessage("Call Scheduled Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        setCallHistoryList(CallHistoryListData?.data);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" && error?.message
          ? error?.message
          : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const closeScheduleEmailPopup = (value = "default", error = null) => {
    showScheduleEmailPopup(false);
    setSelectedHistory(null);
    if (value === "success") {
      setSuccessMessage("Email Scheduled Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        setCallHistoryList(CallHistoryListData?.data);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" && error?.message
          ? error?.message
          : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const closeInstantCallPopup = (value = "default", error = null) => {
    setShowInstantCallPopup({
      visible: false,
      data: null,
    });
    if (value === "success") {
      setSuccessMessage("Call Scheduled Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" ? error?.message : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const closeInstantEmailPopup = (value = "default", error = null) => {
    setShowInstantEmailPopup({
      visible: false,
      data: null,
    });
    if (value === "success") {
      setSuccessMessage("Email Sent successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" ? error?.message : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const onViewTranscript = async (call) => {
    if (call?.contactId && call?.contactId != "N/A") {
      navigate(`/chat/individual/${call?.contactId}/${call?.assistantId}`);
    } else {
      navigate(`/chat/individual-external/${call?.callId}/${0}`);
    }
  };

  const getCallHistoryData = async (page = 1, limit) => {
    setIsLoading(true);
    const result = await dispatch(
      getCallHistoryList({ searchText, page, limit })
    );
    setIsLoading(false);
    dispatch(setPage(result?.payload?.pagination?.page));
    dispatch(setTotalItems(result?.payload?.pagination?.total));
    dispatch(setTotalPages(result?.payload?.pagination?.totalPages));
  };

  const setPageList = (historyData) => {
    if (!!historyData) {
      return historyData.map((item, index) => {
        return {
          ...item,
          callDateTime: moment(item.callTime).format("DD/MM/YYYY hh:mm A"),
        };
      });
    }
  };

  useEffect(() => {
    if (CallHistoryListData) {
      setCallHistoryList(CallHistoryListData?.data);
    }
  }, [CallHistoryListData]);

  const debouncedGetHistoryList = useCallback(
    debounce(getCallHistoryData, 500),
    [searchQuery]
  );

  useEffect(() => {
    debouncedGetHistoryList(1, localItemsPerPage);
  }, [searchQuery, debouncedGetHistoryList]);

  useEffect(() => {
    setCallHistoryList([]);
    dispatch(setPage(1));
    dispatch(setTotalItems(0));
    dispatch(setTotalPages(1));
    getCallHistoryData();
  }, []);

  const columns = [
    {
      label: "Full Name",
      key: "fullName",
      avatarKey: "avatar",
      className: "profile",
    },
    {
      label: "Phone Number",
      key: "phoneNumber",
      className: "cellText",
    },
    {
      label: "Email",
      key: "email",
      className: "cellText",
    },
    {
      label: "Assistant Name",
      key: "assistantName",
      className: "cellText",
    },
    {
      label: "Call date and time",
      key: "callDateTime",
      className: "cellText",
    },
    {
      label: "Type",
      key: "type",
      className: "infoChip",
    },
    {
      label: "Status",
      key: "status",
      className: "statusChip",
      successChip: "Success",
      endChip: "Call ended",
      failedChip: "Failed",
    },
    // {
    //   label: "Summary",
    //   key: "summary",
    //   className: "cellText",
    // },
  ];

  const actionMenus = [];

  if (userPlanFeatures?.OUT_BOUND_CALL) {
    actionMenus.push(
      {
        title: "Instant Call",
        type: "INSTANT_CALL",
        onClick: (rowData) => {
          onCallInstant(rowData);
        },
      },
      {
        title: "Schedule Call",
        type: "SCHEDULE_CALL",
        onClick: (rowData) => {
          onScheduleCall(rowData);
        },
      }
    );
  }

  if (userPlanFeatures?.WEB_CALLS) {
    actionMenus.push(
      {
        title: "Instant Email",
        type: "INSTANT_EMAIL",
        onClick: (rowData) => {
          onEmailInstant(rowData);
        },
      },
      {
        title: "Schedule Email",
        type: "SCHEDULE_EMAIL",
        onClick: (rowData) => {
          onScheduleEmail(rowData);
        },
      }
    );
  }

  if (userPlanFeatures?.CALL_SUMMARY) {
    actionMenus.push(
      {
        title: "Show Summary",
        type: "VIEW_SUMMARY",
        onClick: (rowData) => {
          setSummaryPop({
            visible: true,
            data: rowData?.summary,
          });
        },
      },
      {
        title: "Show Transcript",
        type: "VIEW_TRANSCRIPT",
        onClick: (rowData) => onViewTranscript(rowData),
      }
    );
  }

  const onClickRowData = (rowData) => {
    const { type } = rowData;
    if (type == "INSTANT_CALL") {
      onCallInstant(rowData, true);
    } else if (type == "SCHEDULE_CALL") {
      showSchedulePopup(true);
    } else if (type == "INSTANT_EMAIL") {
      onEmailInstant(rowData, true);
    } else if (type == "SCHEDULE_EMAIL") {
      showScheduleEmailPopup(true);
    }
  };

  const onCallInstant = (rowData, isMultiple) => {
    setShowInstantCallPopup({
      visible: true,
      data: rowData,
      isMultiple: isMultiple ?? false,
    });
  };

  const onEmailInstant = (rowData, isMultiple) => {
    setShowInstantEmailPopup({
      visible: true,
      data: rowData,
      isMultiple: isMultiple ?? false,
    });
  };
  const onScheduleCall = (rowData) => {
    setSelectedHistory(rowData);
    showSchedulePopup(true);
  };

  const onScheduleEmail = (rowData) => {
    setSelectedHistory(rowData);
    showScheduleEmailPopup(true);
  };

  const onRowSelect = (rowData) => {
    const currentList = callHistoryList;
    const setCurrentList = setCallHistoryList;
    if (rowData === "all") {
      const list = currentList.map((history) => ({
        ...history,
        checkedRow: allChecked ? false : true,
      }));
      return setCurrentList(list);
    } else if (rowData === "clear_all") {
      const list = currentList.map((history) => ({
        ...history,
        checkedRow: false,
      }));
      return setCurrentList(list);
    } else {
      const list = currentList.map((history) => {
        if (history.id === rowData.id) {
          return {
            ...history,
            checkedRow: !history.checkedRow,
          };
        } else {
          return {
            ...history,
          };
        }
      });
      return setCurrentList(list);
    }
  };

  const currentSelectedRowsCount = useMemo(() => {
    const list = callHistoryList.filter((history) => history?.checkedRow);
    return list?.length;
  }, [callHistoryList]);

  const isRowChecked = () => {
    const found = callHistoryList.find((x) => x.checkedRow === true);
    if (found) {
      return true;
    } else {
      return false;
    }
  };

  const getSelectedList = () => {
    if (selectedHistory) {
      return [selectedHistory?.id];
    }
    const checkedRows = callHistoryList.filter((x) => x.checkedRow === true);
    return checkedRows.map((x) => x.id);
  };

  return (
    <>
      <div className="page__body">
        {errorModel ? <ErrorModel message={errorMessage} /> : ""}
        {successModel ? <SuccessModel message={successMessage} /> : ""}
        {isLoading ? <Loader /> : ""}
        {showInstantCallPopup.visible ? (
          <CallInstantModal
            closePopup={closeInstantCallPopup}
            currentContact={showInstantCallPopup.data}
            isMultiple={showInstantCallPopup?.isMultiple}
            contactsList={getSelectedList}
            isForCallId
          />
        ) : null}
        {showInstantEmailPopup.visible ? (
          <InstantEmailModal
            closePopup={closeInstantEmailPopup}
            currentContact={showInstantEmailPopup.data}
            isMultiple={showInstantEmailPopup?.isMultiple}
            contactsList={getSelectedList}
            isForCallId
          />
        ) : null}
        {schedulePopup ? (
          <ScheduleCallPopup
            closePopup={closePopup}
            contactsList={getSelectedList}
            isForCallId
          />
        ) : (
          ""
        )}
        {scheduleEmailPopup ? (
          <ScheduleEmailPopup
            closePopup={closeScheduleEmailPopup}
            contactsList={getSelectedList}
            isForCallId
          />
        ) : (
          ""
        )}
        {summaryPopup.visible ? (
          <ChatSummaryPopup
            summary={summaryPopup.data}
            onClose={() => setSummaryPop(INITIAL_SUMMARY_POPUP)}
            onClickOriginalMsg={() => {}}
            isFromCallHistory
          />
        ) : null}
        <div className="tabsContent">
          <div className="tabsContent__content tabsContent__content--selected">
            <div className="tableWrap">
              <div className="tableWrap__head tableWrap__head--wrap">
                <div className="formRow m_0 w_100 formRow--flexEnd">
                  <div className="formCol formCol--flex">
                    <div className="formCol flexField">
                      <input
                        className="form__input form__input--search"
                        type="text"
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value.trimStart());
                        }}
                        spellCheck="false"
                        placeholder="Search by full name, email or phone number"
                      />
                    </div>
                  </div>
                </div>
                <div className="btn__group">
                  {isRowChecked() ? (
                    <>
                      <button
                        type="button"
                        className="btn btn__primary btn__outlined btn__circle"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                      >
                        <svg
                          width={6}
                          height={24}
                          viewBox="0 0 6 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx={3} cy={3} r={3} fill="#8b58f1" />
                          <circle cx={3} cy={12} r={3} fill="#8b58f1" />
                          <circle cx={3} cy={21} r={3} fill="#8b58f1" />
                        </svg>
                      </button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        {Array.isArray(actionMenus)
                          ? actionMenus?.map((item, index) => (
                              <MenuItem
                                key={`${item?.title}-${index}`}
                                sx={{
                                  padding: ".70rem 1rem",
                                  fontSize: ".75rem",
                                  fontWeight: "400",
                                  width: 160,
                                }}
                                onClick={() => {
                                  handleClose();
                                  if (typeof item?.onClick == "function") {
                                    onClickRowData(item);
                                  }
                                }}
                              >
                                {item?.title}
                              </MenuItem>
                            ))
                          : null}
                      </Menu>
                    </>
                  ) : null}
                </div>
              </div>
              {currentSelectedRowsCount > 0 ? (
                <div className="tableWrap__record">
                  <h3 className="title">
                    Contacts ({currentSelectedRowsCount} of{" "}
                    {
                      (Array.isArray(setPageList(callHistoryList))
                        ? setPageList(callHistoryList)
                        : []
                      )?.length
                    }{" "}
                    Selected)
                  </h3>
                  <button
                    className="btn btn__white"
                    onClick={() => {
                      onRowSelect("clear_all");
                    }}
                  >
                    Clear Selection
                  </button>
                </div>
              ) : null}
              <Table
                data={setPageList(callHistoryList)}
                columns={columns}
                hasAction="true"
                allChecked={allChecked}
                hasCheckBox={onRowSelect}
                isShowActionMenu
                actionMenus={actionMenus}
                onClickLink={(rowData) => {}}
                noDataMsg={
                  searchQuery && searchQuery?.length
                    ? `No Call/Email History Found!`
                    : `No Call/Email History!`
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Pagination
        apiMethod={getCallHistoryData}
        itemsPerPage={localItemsPerPage}
        setItemsPerPage={setLocalItemsPerPage}
      />
      {showLowCreditModal ? (
        <LowCreditModal onClose={() => setShowLowCreditModal(false)} />
      ) : null}
    </>
  );
};

export default CallEmailHistoryList;
